/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'msg_recept': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.16 18.01',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="#e60012"><path pid="0" d="M20.62 6.93h-.37V2.69A2.69 2.69 0 0017.56 0H2.69A2.69 2.69 0 000 2.69v8a2.69 2.69 0 002.69 2.69h12.47a5.54 5.54 0 105.45-6.5zM1 10.74v-8a1.68 1.68 0 01.43-1.12l8.63 5.25h.07l8.7-5.28a1.68 1.68 0 01.42 1.11v4.41a5.54 5.54 0 00-4.17 5.32H2.69A1.69 1.69 0 011 10.74zM20.62 17a4.55 4.55 0 01-4.44-3.58v-.14a4.53 4.53 0 01-.08-.82 4.53 4.53 0 013.17-4.26 4.47 4.47 0 011-.2h.37a4.54 4.54 0 110 9.08z"/><path pid="1" d="M19.92 13.56l-1.72-1.95-.75.66 2.44 2.77 3.88-4.05-.72-.69-3.13 3.26z"/></g></g>'
  }
})
